import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UntypedFormControl, UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { Observable, Subscription, map, startWith } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { Customer } from 'src/app/Model/Shipping/customer';
import { CustomerDeliveryDetails } from 'src/app/Model/Shipping/customer-delivery-details';
import { CustomerClass } from 'src/app/Model/Shipping/customer-class';
import { State } from 'src/app/Model/Shipping/state';
import { District } from 'src/app/Model/Shipping/district';
import { City } from 'src/app/Model/Shipping/city';
import { MasterInitialDataWithTwoList } from 'src/app/Model/Shipping/master-initial-data-with-two-list';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { Constant } from 'src/app/Common/constant';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import moment from 'moment';
import { MobileNumberVerificationDialogComponent } from '../mobile-number-verification-dialog/mobile-number-verification-dialog.component';

@Component({
  selector: 'app-create-order-customer',
  templateUrl: './create-order-customer.component.html',
  styleUrls: ['./create-order-customer.component.css']
})
export class CreateOrderCustomerComponent implements OnInit {

  today = new Date();
  yesterday = new Date();

  newCustomer: boolean = true;
  editCustomer: boolean = false;
  showNoCustomerDiv: boolean = false;
  customer: Customer = new Customer();
  loginLocationId: number
  companyCode: number

  deliveryAddressList: CustomerDeliveryDetails[] = [];
  newDeliveryDetails: boolean = true;
  editDeliveryDetails: boolean = false;


  createCustomerForm: UntypedFormGroup;
  // customerDeliveryForm: FormGroup;

  myControl = new UntypedFormControl();
  filteredOptions: Observable<Customer[]>;
  customerSearch: Customer[] = [];
  searchedCustomer: Customer[] = [];
  customerClassList: CustomerClass[] = [];
  masterInitialDataWithTwoList: MasterInitialDataWithTwoList;
  customerOnDataList: string[] = [];
  stateList: State[];
  billingDistrictList: District[];
  billingCityList: City[];
  shippingCityList: City[];

  shippingDistrictList: District[];
  selectedCustomer: Customer = new Customer();
  customerOpeningBalanceTypes: string[] = ['Credit', 'Debit'];
  selectedDetailsIndex: number;

  customerDeliveryDetails: CustomerDeliveryDetails = new CustomerDeliveryDetails();

  errorLog: ErrorLog = new ErrorLog();

  private customerSearchSubcription: Subscription;
  private customerInitialDataSubscription: Subscription;
  private stateSubscription: Subscription;
  private districtSubscription: Subscription;
  private createCustomerSubscription: Subscription;
  private shiipingaddinsertSubscriptionSubscription: Subscription;
  private getDeliveryDetailsSubscription: Subscription;
  private deleteDeliveryDetailsSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  private intervalSubscription: Subscription;

  constant: Constant = new Constant();

  //Shortcuts
  dilogcloseShortcut = this.constant.dilogcloseShortcut;
  dilogsaveShortcut = this.constant.dilogsaveShortcut;

  constructor(
    private dialogRef: MatDialogRef<CreateOrderCustomerComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private apiUrl: APIFactoryEndPoints,
    private formBuilder: UntypedFormBuilder,
    private shippingManagerService: ShippingManagerService,
    private toastService: ToastrService,
    public persistenceService: LocalStorageService,
    public dialog: MatDialog
  ) {
    this.yesterday.setDate(this.today.getDate() - 1);
    dialogRef.disableClose = true;
    this.selectedCustomer = dialogData.selectedCustomer;
    console.log(this.selectedCustomer);
    this.loginLocationId = this.selectedCustomer.locationCode;
    this.companyCode = this.selectedCustomer.companyCode;
    // this.loginLocationId = JSON.parse(this.persistenceService.get('userDetail')).location.refNo;
  }

  ngOnInit(): void {
    this.onCreateCustomerSetupForm();
    // this.customerDeliverySetup();
    this.getCustomerInitialData();
    this.getStateList();
    if (this.selectedCustomer != null || this.selectedCustomer != undefined) {
      this.addValueToCustomerForm(this.selectedCustomer);
    }
  }
  ngOnDestroy() {
    if (this.customerInitialDataSubscription !== undefined)
      this.customerInitialDataSubscription.unsubscribe();

    if (this.stateSubscription !== undefined)
      this.stateSubscription.unsubscribe();

    if (this.customerSearchSubcription !== undefined)
      this.customerSearchSubcription.unsubscribe();

    if (this.districtSubscription !== undefined)
      this.districtSubscription.unsubscribe();

    if (this.createCustomerSubscription !== undefined)
      this.createCustomerSubscription.unsubscribe();

    if (this.shiipingaddinsertSubscriptionSubscription !== undefined)
      this.shiipingaddinsertSubscriptionSubscription.unsubscribe();

    if (this.getDeliveryDetailsSubscription !== undefined)
      this.getDeliveryDetailsSubscription.unsubscribe();

    if (this.deleteDeliveryDetailsSubscription !== undefined)
      this.deleteDeliveryDetailsSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();

  }

  getCustomerInitialData() {
    this.customerInitialDataSubscription = this.shippingManagerService.getCustomerInitialData(this.apiUrl.getCustomerInitialData, this.loginLocationId).subscribe((data: MasterInitialDataWithTwoList) => {
      this.masterInitialDataWithTwoList = data;
      this.customerClassList = this.masterInitialDataWithTwoList.spinnerListTwo;
      this.customerOnDataList = this.masterInitialDataWithTwoList.spinnerListOne;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getCustomerInitialData", error);
      });
  }

  getStateList() {
    this.stateSubscription = this.shippingManagerService.getStatesList(this.apiUrl.getStatesbyCountryCode, 1).subscribe((data) => {
      this.stateList = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getStateList", error);
      });
  }

  onBillingStateClick(stateCode: number) {
    this.billingCityList = [];
    this.createCustomerForm.get('billingDistrictCode').reset();
    this.createCustomerForm.get('billingCityCode').reset();
    this.districtSubscription = this.shippingManagerService.getDistrictsByStateCode(this.apiUrl.getDistrictsbyStateCodeWithAll, stateCode).subscribe((data: any) => {
      this.billingDistrictList = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onBillingStateClick", error);
      });
  }

  onBillingDistrictClick(districtCode: number) {
    this.createCustomerForm.get('billingCityCode').reset();
    this.districtSubscription = this.shippingManagerService.getDistrictsByStateCode(this.apiUrl.getCityByDistrict, districtCode).subscribe((data: any) => {
      this.billingCityList = data;
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onBillingDistrictClick", error);
      });
  }

  // onShippingStateClick(stateCode: number) {
  //   this.districtSubscription = this.posService.getDistrictsByStateCode(this.apiUrl.getDistrictsbyStateCodeWithAll, stateCode).subscribe((data: any) => {
  //     this.shippingDistrictList = data;
  //   })
  // }

  // onShippingDistrictClick(districtCode: number) {
  //   this.districtSubscription = this.posService.getDistrictsByStateCode(this.apiUrl.getCityByDistrict, districtCode).subscribe((data: any) => {
  //     this.shippingCityList = data;
  //   })
  // }

  onSearchCustomer(mobileNo: string) {
    if (mobileNo.length < 11) {
      if (this.intervalSubscription)
        this.intervalSubscription.unsubscribe();
      const source = this.constant.intervalTimeForSearch;
      this.intervalSubscription = source.subscribe(val => {
        this.intervalSubscription.unsubscribe();

        this.createCustomerForm.reset();
        this.createCustomerForm.enable();
        // this.customerDeliveryForm.reset();
        this.newCustomer = true;
        this.editCustomer = false;
        this.showNoCustomerDiv = false;
        if (mobileNo) {
          this.customerSearchSubcription = this.shippingManagerService.getCustomerSearch(this.apiUrl.getCustomerCustomerWithLocationBymobAndName, mobileNo).subscribe((data: Customer[]) => {
            this.customerSearch = data;
            if (mobileNo.length == 10 && data.length == 0) {
              this.showNoCustomerDiv = true;
              this.createCustomerForm.get('customerMobile').setValue(mobileNo);
              this.createCustomerForm.enable();
            }

            this.filteredOptions = this.myControl.valueChanges
              .pipe(
                startWith(''),
                map(value => this._filter(value))
              );
          },
            (error: HttpErrorResponse) => {
              this.insertErrorLog("onSearchCustomer", error);
            });
        }
      });
    }
    else {
      this.myControl.setValue(mobileNo.substring(0, 10));
    }
  }

  _filter(value: any): Customer[] {
    if (typeof (value) === 'string') {
      let filterValue: string = value.toLowerCase();
      return this.customerSearch.filter((option: Customer) => option.customerName.toLowerCase().includes(filterValue));
    }
  }
  onCustomerSearchSelect(cust: Customer) {
    if (this.intervalSubscription)
      this.intervalSubscription.unsubscribe();
    this.myControl.setValue(cust.customerMobile);
    this.customerSearchSubcription = this.shippingManagerService.getCustomerSearch(this.apiUrl.getCustomerByCustomerCode, cust.refNo).subscribe((customer: Customer) => {

      this.selectedCustomer = customer;
      this.newCustomer = false;
      this.editCustomer = true;
      this.showNoCustomerDiv = false;

      if (customer.stateCode != undefined || customer.stateCode != null) {
        this.onBillingStateClick(customer.stateCode);
      }
      if (customer.billingDistrictCode != undefined || customer.billingDistrictCode != null) {
        this.onBillingDistrictClick(customer.billingDistrictCode);
      }
      this.createCustomerForm.patchValue({
        customerMobile: customer.customerMobile,
        customerName: customer.customerName,
        customerGstin: customer.customerGstin,
        customerClassCode: customer.customerClass?.refNo,
        customerEmail: customer.customerEmail,
        customerDob: customer.customerDob,
        customerAnniversaryDate: customer.customerAnniversaryDate,
        customerCreditLimit: customer.customerCreditLimit,
        customerSpouseName: customer.customerSpouseName,
        customerSpouseDob: customer.customerSpouseDob,
        customerOpeningBalance: customer.customerOpeningBalance,
        customerOpeningBalanceType: customer.customerOpeningBalanceType,
        customerDeliveryDetails: customer.customerDeliveryDetails,

        customerBillingAddress: customer.customerBillingAddress,
        billingLandMark: customer.billingLandMark,
        billingStreet: customer.billingStreet,
        billingPlotNo: customer.billingPlotNo,
        billingPinCode: customer.billingPinCode,
        billingStateCode: customer.stateCode,
        billingDistrictCode: customer.billingDistrictCode,
        billingCityCode: customer.billingCityCode,

        refNo: customer.refNo,
        stateCode: customer.stateCode,
        waVarified: customer.waVarified
      });
      this.verifiedMobileNo = null;
      if (customer.waVarified) {
        this.verifiedMobileNo = customer.customerMobile;
      }
      // this.customerDeliveryForm.reset();
      this.selectedDetailsIndex = null;
      if (customer.customerDeliveryDetails != null && customer.customerDeliveryDetails.length > 0) {
        this.deliveryAddressList = customer.customerDeliveryDetails;
      }
      this.createCustomerForm.disable();
      console.log(this.createCustomerForm.enabled);
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onCustomerSearchSelect", error);
      });
  }


  addValueToCustomerForm(customer: Customer) {
    if (customer.customerName != undefined || customer.customerName != null) {
      this.myControl.setValue(customer.customerMobile);

      if (customer.stateCode != undefined || customer.stateCode != null) {
        this.onBillingStateClick(customer.stateCode);
      }
      if (customer.billingDistrictCode != undefined || customer.billingDistrictCode != null) {
        this.onBillingDistrictClick(customer.billingDistrictCode);
      }
      this.createCustomerForm.patchValue({
        customerMobile: customer.customerMobile,
        customerName: customer.customerName,
        customerGstin: customer.customerGstin,
        customerClassCode: customer.customerClassCode,
        customerEmail: customer.customerEmail,
        customerDob: customer.customerDob,
        customerAnniversaryDate: customer.customerAnniversaryDate,
        customerCreditLimit: customer.customerCreditLimit,
        customerSpouseName: customer.customerSpouseName,
        customerSpouseDob: customer.customerSpouseDob,
        customerOpeningBalance: customer.customerOpeningBalance,
        customerOpeningBalanceType: customer.customerOpeningBalanceType,
        customerDeliveryDetails: customer.customerDeliveryDetails,

        customerBillingAddress: customer.customerBillingAddress,
        billingLandMark: customer.billingLandMark,
        billingStreet: customer.billingStreet,
        billingPlotNo: customer.billingPlotNo,
        billingPinCode: customer.billingPinCode,
        billingCityCode: customer.billingCityCode,
        billingStateCode: customer.stateCode,
        billingDistrictCode: customer.billingDistrictCode,

        refNo: customer.refNo,
        stateCode: customer.stateCode,
        deliveryAddressRefNo: customer.deliveryAddressRefNo,
        waVarified: customer.waVarified
      });
      this.verifiedMobileNo = null;
      if (customer.waVarified) {
        this.verifiedMobileNo = customer.customerMobile;
      }

      this.newCustomer = false;
      this.editCustomer = true;

      // this.customerDeliveryForm.reset();
      this.selectedDetailsIndex = null;
      if (customer.customerDeliveryDetails != null && customer.customerDeliveryDetails.length > 0) {
        this.deliveryAddressList = customer.customerDeliveryDetails;
      }
      this.createCustomerForm.disable();
    }
  }

  onCreateCustomerSetupForm() {
    this.createCustomerForm = this.formBuilder.group({
      customerMobile: [null, [Validators.required, Validators.pattern("[6789][0-9]{9}")]],
      customerName: [null, [Validators.required, Validators.pattern('^[a-zA-Z ]*$')]],
      customerGstin: [null, [Validators.pattern("[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$")]],
      customerEmail: [null, [Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      customerDob: [],
      customerSpouseName: [null, [Validators.pattern('^[a-zA-Z ]*$')]],
      customerSpouseDob: [],
      customerAnniversaryDate: [],
      customerOpeningBalance: [],
      customerOpeningBalanceType: [],
      customerCreditLimit: [],
      customerClassCode: [],
      customerDeliveryDetails: [],

      customerBillingAddress: [],
      billingLandMark: [],
      billingPinCode: [null, [Validators.pattern("[1-9][0-9]{5}")]],
      billingStateCode: [null, Validators.required],
      billingDistrictCode: [],
      billingCityCode: [],
      billingPlotNo: [],
      billingStreet: [],

      refNo: [],
      stateCode: [],
      deliveryAddressRefNo: [],
      waVarified: [false]
    });

  }

  // customerDeliverySetup() {
  //   this.customerDeliveryForm = this.formBuilder.group({
  //     contactName: [null, Validators.required],
  //     contactMobile: [null, [Validators.required, Validators.pattern("[6789][0-9]{9}")]],
  //     shippingAddress: [null, Validators.required],
  //     shippingPlotNo: [null, Validators.required],
  //     shippingStreet: [null, Validators.required],
  //     shippingCityCode: [null, Validators.required],
  //     shippingPinCode: [null, [Validators.required, Validators.pattern("[1-9][0-9]{5}")]],
  //     shippingLandMark: [],

  //     shippingStateCode: [],
  //     shippingDistrictCode: [],
  //     refNo: [],
  //   })
  // }

  selectCustomer() {
    if (this.createCustomerForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
      return;
    }
    this.toastService.showSuccessToast(this.createCustomerForm.get('customerName').value + ' Selected');
    this.dialogRef.close({ data: this.createCustomerForm.value });
  }

  resetCustomer() {
    this.createCustomerForm.reset();
    this.newCustomer = true;
    this.editCustomer = false;
    this.dialogData = null;
    this.myControl.reset();
  }

  hide() {
    if (this.createCustomerForm.invalid) {
      this.createCustomerForm.reset();
    }
    this.dialogRef.close({ data: this.createCustomerForm.value });
  }

  onEditClick() {
    this.createCustomerForm.enable();
    this.editCustomer = true;
    this.newCustomer = true;
  }

  saveCustomer() {
    if (this.createCustomerForm.get('customerName').value) {
      this.createCustomerForm.get('customerName').setValue(this.createCustomerForm.get('customerName').value.trim());
    }
    if (this.createCustomerForm.get('customerGstin').value) {
      this.createCustomerForm.get('customerGstin').setValue(this.createCustomerForm.get('customerGstin').value.trim());
    }
    if (this.createCustomerForm.get('customerEmail').value) {
      this.createCustomerForm.get('customerEmail').setValue(this.createCustomerForm.get('customerEmail').value.trim());
    }
    if (this.createCustomerForm.get('customerSpouseName').value) {
      this.createCustomerForm.get('customerSpouseName').setValue(this.createCustomerForm.get('customerSpouseName').value.trim());
    }
    if (this.createCustomerForm.get('customerBillingAddress').value) {
      this.createCustomerForm.get('customerBillingAddress').setValue(this.createCustomerForm.get('customerBillingAddress').value.trim());
    }
    if (this.createCustomerForm.get('billingPlotNo').value) {
      this.createCustomerForm.get('billingPlotNo').setValue(this.createCustomerForm.get('billingPlotNo').value.trim());
    }
    if (this.createCustomerForm.get('billingStreet').value) {
      this.createCustomerForm.get('billingStreet').setValue(this.createCustomerForm.get('billingStreet').value.trim());
    }
    if (this.createCustomerForm.get('billingLandMark').value) {
      this.createCustomerForm.get('billingLandMark').setValue(this.createCustomerForm.get('billingLandMark').value.trim());
    }

    if (this.createCustomerForm.invalid) {
      this.toastService.showErrorToast(this.constant.invalidFormToast);
    }
    else if (this.createCustomerForm.get('customerOpeningBalance').value != null && this.createCustomerForm.get('customerOpeningBalanceType').value == null) {
      this.createCustomerForm.get('customerOpeningBalanceType').setValidators(Validators.required);
      this.toastService.showErrorToast(this.constant.selectOpeningBalanceTypToast);
    }

    else {
      // ----------------------Date Format----------------------
      let momentDate;
      let formattedDate;
      if (this.createCustomerForm.get('customerDob').value != null) {
        momentDate = new Date(this.createCustomerForm.get('customerDob').value);
        formattedDate = moment(momentDate).format(this.constant.dateFormatForDBServer);
        this.customer.customerDob = formattedDate;
      }
      if (this.createCustomerForm.get('customerAnniversaryDate').value != null) {
        momentDate = new Date(this.createCustomerForm.get('customerAnniversaryDate').value);
        formattedDate = moment(momentDate).format(this.constant.dateFormatForDBServer);
        this.customer.customerAnniversaryDate = formattedDate;
      }
      if (this.createCustomerForm.get('customerSpouseDob').value != null) {
        momentDate = new Date(this.createCustomerForm.get('customerSpouseDob').value);
        formattedDate = moment(momentDate).format(this.constant.dateFormatForDBServer);
        this.customer.customerSpouseDob = formattedDate;
      }

      if (this.createCustomerForm.get('customerGstin').value == "") {
        this.customer.customerGstin = null
      }
      else {
        this.customer.customerGstin = this.createCustomerForm.get('customerGstin').value;
      }
      if (this.createCustomerForm.get('customerEmail').value == "") {
        this.customer.customerEmail = null
      }
      else {
        this.customer.customerEmail = this.createCustomerForm.get('customerEmail').value;
      }

      this.customer.fromLocationCode = this.loginLocationId
      this.customer.customerMobile = this.createCustomerForm.get('customerMobile').value;
      this.customer.customerName = this.createCustomerForm.get('customerName').value;
      this.customer.customerClassCode = this.createCustomerForm.get('customerClassCode').value;
      this.customer.customerSpouseName = this.createCustomerForm.get('customerSpouseName').value;
      this.customer.customerCreditLimit = this.createCustomerForm.get('customerCreditLimit').value;
      this.customer.customerOpeningBalance = this.createCustomerForm.get('customerOpeningBalance').value;
      this.customer.customerOpeningBalanceType = this.createCustomerForm.get('customerOpeningBalanceType').value;
      this.customer.customerDeliveryDetails = this.createCustomerForm.get('customerDeliveryDetails').value;
      if (this.customer.customerDeliveryDetails == null) {
        this.customer.customerDeliveryDetails = [];
      }

      this.customer.customerBillingAddress = this.createCustomerForm.get('customerBillingAddress').value;
      this.customer.billingLandMark = this.createCustomerForm.get('billingLandMark').value;
      this.customer.billingStreet = this.createCustomerForm.get('billingStreet').value;
      this.customer.billingPlotNo = this.createCustomerForm.get('billingPlotNo').value;
      this.customer.billingPinCode = this.createCustomerForm.get('billingPinCode').value;
      this.customer.billingCityCode = this.createCustomerForm.get('billingCityCode').value;
      this.customer.billingDistrictCode = this.createCustomerForm.get('billingDistrictCode').value;
      this.customer.stateCode = this.createCustomerForm.get('billingStateCode').value;
      this.customer.refNo = this.createCustomerForm.get('refNo').value;
      this.customer.waVarified = this.createCustomerForm.get('waVarified').value;
      this.customer.moduleName = this.selectedCustomer.moduleName;

      this.createCustomerForm.get('stateCode').setValue(this.createCustomerForm.get('billingStateCode').value);

      this.createCustomerSubscription = this.shippingManagerService.insertCustomer(this.apiUrl.insertCustomerFromOtherModules, this.customer).subscribe((response:any) => {
        if (this.customer.refNo == null || this.customer.refNo == undefined || this.customer.refNo == "") {
          this.toastService.showSuccessToast("Customer " + this.createCustomerForm.get('customerName').value + this.constant.savedSuccessfullyWithModuleToast);
        }
        else {
          this.toastService.showSuccessToast("Customer " + this.createCustomerForm.get('customerName').value + this.constant.savedSuccessfullyWithModuleToast);
        }

        this.createCustomerForm.get('customerOpeningBalanceType').setValidators(Validators.nullValidator);
        this.createCustomerForm.get('refNo').setValue(response.data);

        this.newCustomer = false;
        this.editCustomer = true;
        this.showNoCustomerDiv = false;
        this.createCustomerForm.disable();
      },
        (error: HttpErrorResponse) => {
          this.insertErrorLog("saveCustomer", error);
        });
    }
  }

  // onShippingAddressSaveClick() {
  //   if (this.customerDeliveryForm.invalid) {
  //     this.toastService.showErrorToast(this.constant.invalidFormToast);
  //     return;
  //   }
  //   this.customerDeliveryDetails.shippingAddress = this.customerDeliveryForm.get('shippingAddress').value;
  //   this.customerDeliveryDetails.shippingPlotNo = this.customerDeliveryForm.get('shippingPlotNo').value;
  //   this.customerDeliveryDetails.shippingStreet = this.customerDeliveryForm.get('shippingStreet').value;
  //   this.customerDeliveryDetails.shippingCityCode = this.customerDeliveryForm.get('shippingCityCode').value;
  //   this.customerDeliveryDetails.shippingLandMark = this.customerDeliveryForm.get('shippingLandMark').value;
  //   this.customerDeliveryDetails.shippingPinCode = this.customerDeliveryForm.get('shippingPinCode').value;
  //   this.customerDeliveryDetails.contactMobile = this.customerDeliveryForm.get('contactMobile').value;
  //   this.customerDeliveryDetails.contactName = this.customerDeliveryForm.get('contactName').value;
  //   this.customerDeliveryDetails.refNo = this.customerDeliveryForm.get('refNo').value;

  //   this.customerDeliveryDetails.customerCode = this.createCustomerForm.get('refNo').value;

  //   this.shiipingaddinsertSubscriptionSubscription = this.posService.insertCustomerDeliveryDetails(this.apiUrl.insertCustomerDeliveryDetails, this.customerDeliveryDetails).subscribe((data) => {
  //     this.toastService.showSuccessToast("Customer Delivery Address Saved");
  //     this.customerDeliveryForm.reset();
  //     this.verifiedMobileNo = null;
  //     this.deliveryAddressList = [];
  //     this.selectedDetailsIndex = null;
  //     this.newDeliveryDetails = false;
  //     this.editDeliveryDetails = true;
  //     this.customerDeliveryForm.disable();
  //     this.getDeliveryDetailsByCustomerCode(this.customerDeliveryDetails.customerCode);
  //   })

  // }

  // getDeliveryDetailsByCustomerCode(customerCode: string) {
  //   this.getDeliveryDetailsSubscription = this.posService.getCustomerDeliveryDetailsByCustomerCode(this.apiUrl.getCustomerDeliveryDetailsByCustomerCode, customerCode).subscribe((data: any) => {
  //     this.deliveryAddressList = data;
  //     this.createCustomerForm.patchValue({
  //       customerDeliveryDetails: this.deliveryAddressList
  //     });
  //   });
  // }

  // onDeliveryDetailSelect(data: CustomerDeliveryDetails, index: number) {
  //   if (index) {
  //     this.deliveryAddressList.forEach(element => {
  //       if (element.defaultAddress) {
  //         element.defaultAddress = false;
  //       }
  //     })
  //     this.deliveryAddressList[index].defaultAddress = true;
  //   }
  //   this.createCustomerForm.get('deliveryAddressRefNo').setValue(data.refNo);
  //   this.selectedDetailsIndex = index;
  //   this.onShippingStateClick(data.shippingCity.district.stateCode);
  //   this.onShippingDistrictClick(data.shippingCity.districtCode);

  //   this.customerDeliveryForm.patchValue({
  //     contactName: data.contactName,
  //     contactMobile: data.contactMobile,
  //     shippingAddress: data.shippingAddress,
  //     shippingPlotNo: data.shippingPlotNo,
  //     shippingStreet: data.shippingStreet,
  //     shippingStateCode: data.shippingCity.district.stateCode,
  //     shippingDistrictCode: data.shippingCity.districtCode,
  //     shippingCityCode: data.shippingCity.refNo,
  //     shippingLandMark: data.shippingLandMark,
  //     shippingPinCode: data.shippingPinCode,
  //     refNo: data.refNo
  //   })
  //   this.newDeliveryDetails = false;
  //   this.editDeliveryDetails = true;
  //   this.customerDeliveryForm.disable();
  // }
  // onDeleteDetailClick(refNo: number, customerCode: string) {
  //   console.log(refNo);
  //   let headingMessage = "This address will be removed permanently";
  //   let subMessage = "Do you want to proceed";

  //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
  //     height: '158px',
  //     width: '346px',
  //     data: { heading: headingMessage, message: subMessage }
  //   });

  //   dialogRef.afterClosed().subscribe(result => {
  //     if (result) {
  //       this.deleteDeliveryDetailsSubscription = this.posService.deleteCustomerDeliveryDetailsById(this.apiUrl.deleteCustomerDeliveryDetailsById, refNo).subscribe((data) => {
  //         this.toastService.showSuccessToast("Customer Delivery Details Deleted");
  //         this.customerDeliveryForm.reset();
  //         this.deliveryAddressList = [];
  //         this.selectedDetailsIndex = null;
  //         this.getDeliveryDetailsByCustomerCode(customerCode);
  //       })
  //     }
  //   })
  // }

  // onEditDeliveryDataClick() {
  //   this.customerDeliveryForm.enable();
  //   this.newDeliveryDetails = true;
  //   this.editDeliveryDetails = false;
  // }

  // onDeliveryDataSelectClick() {
  //   this.dialogRef.close({ data: this.createCustomerForm.value });
  // }

  // setDeliveryData() {

  //   this.onShippingStateClick(this.createCustomerForm.get('billingStateCode').value);
  //   if (this.createCustomerForm.get('billingDistrictCode').value != null) {
  //     this.onShippingDistrictClick(this.createCustomerForm.get('billingDistrictCode').value);
  //   }

  //   this.customerDeliveryForm.patchValue({
  //     contactName: this.createCustomerForm.get('customerName').value,
  //     contactMobile: this.createCustomerForm.get('customerMobile').value,
  //     shippingAddress: this.createCustomerForm.get('customerBillingAddress').value,
  //     shippingPlotNo: this.createCustomerForm.get('billingPlotNo').value,
  //     shippingStreet: this.createCustomerForm.get('billingStreet').value,
  //     shippingStateCode: this.createCustomerForm.get('billingStateCode').value,
  //     shippingDistrictCode: this.createCustomerForm.get('billingDistrictCode').value,
  //     shippingCityCode: this.createCustomerForm.get('billingCityCode').value,
  //     shippingLandMark: this.createCustomerForm.get('billingLandMark').value,
  //     shippingPinCode: this.createCustomerForm.get('billingPinCode').value,
  //   })
  // }

  verifiedMobileNo: string;
  onVerifyMobileNoClick() {
    if (this.createCustomerForm.get('customerMobile').invalid) {
      this.toastService.clearAllToast();
      this.toastService.showErrorToast(this.constant.invalidMobileToast);
      return;
    }
    console.log("Verified");
    let dialogRef = this.dialog.open(MobileNumberVerificationDialogComponent, {
      width: '270px',
      height: '145px',
      data: { data: this.createCustomerForm.get('customerMobile').value, companyCode: this.companyCode }
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        this.createCustomerForm.get('waVarified').setValue(res.verified);
        this.verifiedMobileNo = res.mobileNo;
      }
    })
  }
  onEnterMobileNo(mobileNo: string) {
    if (this.verifiedMobileNo == mobileNo) {
      this.createCustomerForm.get('waVarified').setValue(true);
    }
    else {
      this.createCustomerForm.get('waVarified').setValue(false);
    }
  }

  clearBirthDate() {
    this.createCustomerForm.get('customerDob').setValue(null);
  }
  clearSpouseDate() {
    this.createCustomerForm.get('customerSpouseDob').setValue(null);
  }
  clearAnniversaryDate() {
    this.createCustomerForm.get('customerAnniversaryDate').setValue(null);
  }

  validateInput(event: any, field: string) {
    if (field === 'mobile') {

    } else if (field === 'pinCode') {
    }
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Customer(Others)";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message || error?.error?.message != '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiUrl.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }
}


